module.exports = __webpack_public_path__ + "WxrXJa0C3KdtC7lMafG4dRkAz4rYn47Zy2rvigWQf6w.703161fc2b135039e2f3.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/WxrXJa0C3KdtC7lMafG4dRkAz4rYn47Zy2rvigWQf6w.woff2
// module id = ../../../../../src/assets/fonts/font-google/WxrXJa0C3KdtC7lMafG4dRkAz4rYn47Zy2rvigWQf6w.woff2
// module chunks = 40